import { FC } from 'react';

import * as Styled from './DottedLine.styled';

export enum DottedLineVariant {
	Primary = 'Primary',
	Secondary = 'Secondary',
}

export interface DottedLineProps {
	variant?: DottedLineVariant;
	img: ImgType;
	filter?: FilterImg;
	filterColor?: string;
	onlyMobile: boolean;
}

export enum ImgType {
	dottedLine = 'Without Border',
	dottedLineWithBorder = 'With Border',
}

export enum FilterImg {
	default = 'Default',
	gray = 'Grey',
	red = 'Red',
}

const getFilter = (filter?: FilterImg) => {
	switch (filter) {
		case FilterImg.gray:
			return 'invert(70%) sepia(1%) saturate(6%) hue-rotate(44deg) brightness(97%) contrast(96%)';
		case FilterImg.red:
			return 'invert(14%) sepia(65%) saturate(6128%) hue-rotate(351deg) brightness(56%) contrast(87%)';
		default:
			return 'none';
	}
};

export const DottedLine: FC<DottedLineProps> = ({ variant, img, filter, onlyMobile }) => {
	return (
		<Styled.Container
			variant={variant}
			img={img}
			filterColor={getFilter(filter)}
			onlyMobile={onlyMobile}
			aria-hidden='true'
			tabIndex={-1}
		>
			<Styled.DottedLineImage data-testid='dottedLine' filterColor={getFilter(filter)} img={img} />
			{variant === DottedLineVariant.Secondary && (
				<Styled.LogoImage
					data-testid={'logo-image'}
					src='https://edge.sitecorecloud.io/osi-60501bcc/media/Project/BBI/outback/App/app-logo.webp'
				/>
			)}
		</Styled.Container>
	);
};
